/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminProjectMatchDataResponse,
  AdminProjectResponse,
  AdminProjectTeamMatchDataResponse,
  BodyBatchImportProjects,
  CreateProjectRecommendation200,
  GetProjectMatchDataParams,
  GetProjectTeamMatchDataParams,
  GetProjectsParams,
  HTTPValidationError,
  ProjectRecommendationRequest,
  ReviewProject,
  UpdatePublishStageRequest,
} from './platformapi.schemas';

import getProjectsMutator from '../custom-axios-instance';
import batchImportProjectsMutator from '../custom-axios-instance';
import getProjectMatchDataMutator from '../custom-axios-instance';
import getProjectTeamMatchDataMutator from '../custom-axios-instance';
import getReviewProjectMutator from '../custom-axios-instance';
import createProjectRecommendationMutator from '../custom-axios-instance';
import updatePublishStageMutator from '../custom-axios-instance';

/**
 * Fetch list of projects with pagination, sorting and filtering applied. Returns the list as well as the total count of projects matching the filter criteria.
 * @summary Get Projects
 */
export const getProjects = (params?: GetProjectsParams, signal?: AbortSignal) => {
  return getProjectsMutator<AdminProjectResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/projects/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProjectsQueryKey = (params?: GetProjectsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/projects/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) =>
    getProjects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>;
export type GetProjectsQueryError = void | HTTPValidationError;

export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetProjectsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Projects
 */

export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError = void | HTTPValidationError,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Accepts csv batch of projects. Creates the database project records
 * @summary Batch Import Projects
 */
export const batchImportProjects = (
  bodyBatchImportProjects: BodyBatchImportProjects,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, bodyBatchImportProjects.file);

  return batchImportProjectsMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/projects/batch-import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getBatchImportProjectsMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchImportProjects>>,
    TError,
    { data: BodyBatchImportProjects },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchImportProjects>>,
  TError,
  { data: BodyBatchImportProjects },
  TContext
> => {
  const mutationKey = ['batchImportProjects'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchImportProjects>>,
    { data: BodyBatchImportProjects }
  > = (props) => {
    const { data } = props ?? {};

    return batchImportProjects(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchImportProjectsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchImportProjects>>
>;
export type BatchImportProjectsMutationBody = BodyBatchImportProjects;
export type BatchImportProjectsMutationError = void | HTTPValidationError;

/**
 * @summary Batch Import Projects
 */
export const useBatchImportProjects = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchImportProjects>>,
      TError,
      { data: BodyBatchImportProjects },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchImportProjects>>,
  TError,
  { data: BodyBatchImportProjects },
  TContext
> => {
  const mutationOptions = getBatchImportProjectsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Project Match Data
 */
export const getProjectMatchData = (params: GetProjectMatchDataParams, signal?: AbortSignal) => {
  return getProjectMatchDataMutator<AdminProjectMatchDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/projects/matching`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProjectMatchDataQueryKey = (params?: GetProjectMatchDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/projects/matching`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProjectMatchDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectMatchData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectMatchDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectMatchData>>> = ({ signal }) =>
    getProjectMatchData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectMatchData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectMatchDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectMatchData>>
>;
export type GetProjectMatchDataQueryError = void | HTTPValidationError;

export function useGetProjectMatchData<
  TData = Awaited<ReturnType<typeof getProjectMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectMatchDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectMatchData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectMatchData>>,
          TError,
          Awaited<ReturnType<typeof getProjectMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectMatchData<
  TData = Awaited<ReturnType<typeof getProjectMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectMatchData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectMatchData>>,
          TError,
          Awaited<ReturnType<typeof getProjectMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectMatchData<
  TData = Awaited<ReturnType<typeof getProjectMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Project Match Data
 */

export function useGetProjectMatchData<
  TData = Awaited<ReturnType<typeof getProjectMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectMatchDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Project Team Match Data
 */
export const getProjectTeamMatchData = (
  params: GetProjectTeamMatchDataParams,
  signal?: AbortSignal,
) => {
  return getProjectTeamMatchDataMutator<AdminProjectTeamMatchDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/projects/matching-teams`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProjectTeamMatchDataQueryKey = (params?: GetProjectTeamMatchDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/projects/matching-teams`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProjectTeamMatchDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectTeamMatchData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectTeamMatchDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectTeamMatchData>>> = ({
    signal,
  }) => getProjectTeamMatchData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectTeamMatchData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectTeamMatchDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectTeamMatchData>>
>;
export type GetProjectTeamMatchDataQueryError = void | HTTPValidationError;

export function useGetProjectTeamMatchData<
  TData = Awaited<ReturnType<typeof getProjectTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectTeamMatchDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectTeamMatchData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectTeamMatchData>>,
          TError,
          Awaited<ReturnType<typeof getProjectTeamMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectTeamMatchData<
  TData = Awaited<ReturnType<typeof getProjectTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectTeamMatchData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectTeamMatchData>>,
          TError,
          Awaited<ReturnType<typeof getProjectTeamMatchData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectTeamMatchData<
  TData = Awaited<ReturnType<typeof getProjectTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectTeamMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Project Team Match Data
 */

export function useGetProjectTeamMatchData<
  TData = Awaited<ReturnType<typeof getProjectTeamMatchData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProjectTeamMatchDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectTeamMatchData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectTeamMatchDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves a single project to review
 * @summary Get Review Project
 */
export const getReviewProject = (projectId: number, signal?: AbortSignal) => {
  return getReviewProjectMutator<ReviewProject>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/projects/projects/review/${projectId}`,
    method: 'GET',
    signal,
  });
};

export const getGetReviewProjectQueryKey = (projectId?: number) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/projects/projects/review/${projectId}`,
  ] as const;
};

export const getGetReviewProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewProject>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewProject>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReviewProjectQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewProject>>> = ({ signal }) =>
    getReviewProject(projectId, signal);

  return { queryKey, queryFn, enabled: !!projectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReviewProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getReviewProject>>>;
export type GetReviewProjectQueryError = void | HTTPValidationError;

export function useGetReviewProject<
  TData = Awaited<ReturnType<typeof getReviewProject>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewProject>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewProject>>,
          TError,
          Awaited<ReturnType<typeof getReviewProject>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewProject<
  TData = Awaited<ReturnType<typeof getReviewProject>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewProject>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewProject>>,
          TError,
          Awaited<ReturnType<typeof getReviewProject>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewProject<
  TData = Awaited<ReturnType<typeof getReviewProject>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewProject>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Review Project
 */

export function useGetReviewProject<
  TData = Awaited<ReturnType<typeof getReviewProject>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewProject>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReviewProjectQueryOptions(projectId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a project recommendation
 * @summary Create Project Recommendation
 */
export const createProjectRecommendation = (
  projectRecommendationRequest: ProjectRecommendationRequest,
  signal?: AbortSignal,
) => {
  return createProjectRecommendationMutator<CreateProjectRecommendation200>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/projects/recommendations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: projectRecommendationRequest,
    signal,
  });
};

export const getCreateProjectRecommendationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectRecommendation>>,
    TError,
    { data: ProjectRecommendationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProjectRecommendation>>,
  TError,
  { data: ProjectRecommendationRequest },
  TContext
> => {
  const mutationKey = ['createProjectRecommendation'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProjectRecommendation>>,
    { data: ProjectRecommendationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createProjectRecommendation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectRecommendationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProjectRecommendation>>
>;
export type CreateProjectRecommendationMutationBody = ProjectRecommendationRequest;
export type CreateProjectRecommendationMutationError = void | HTTPValidationError;

/**
 * @summary Create Project Recommendation
 */
export const useCreateProjectRecommendation = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProjectRecommendation>>,
      TError,
      { data: ProjectRecommendationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProjectRecommendation>>,
  TError,
  { data: ProjectRecommendationRequest },
  TContext
> => {
  const mutationOptions = getCreateProjectRecommendationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates the publishing stage of a project
 * @summary Update Publish Stage
 */
export const updatePublishStage = (
  updatePublishStageRequest: UpdatePublishStageRequest,
  signal?: AbortSignal,
) => {
  return updatePublishStageMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/projects/update-publish-stage`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updatePublishStageRequest,
    signal,
  });
};

export const getUpdatePublishStageMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePublishStage>>,
    TError,
    { data: UpdatePublishStageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePublishStage>>,
  TError,
  { data: UpdatePublishStageRequest },
  TContext
> => {
  const mutationKey = ['updatePublishStage'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePublishStage>>,
    { data: UpdatePublishStageRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updatePublishStage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePublishStageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePublishStage>>
>;
export type UpdatePublishStageMutationBody = UpdatePublishStageRequest;
export type UpdatePublishStageMutationError = void | HTTPValidationError;

/**
 * @summary Update Publish Stage
 */
export const useUpdatePublishStage = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePublishStage>>,
      TError,
      { data: UpdatePublishStageRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePublishStage>>,
  TError,
  { data: UpdatePublishStageRequest },
  TContext
> => {
  const mutationOptions = getUpdatePublishStageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
